export default {
    "REGISTER_TITLE_1": "Enregistrez votre compte facilement et commencez à trader.",
    "REGISTER": "S'inscrire",
    "ALREADY_HAVE_ACCOUNT": "Vous avez déjà un compte?",
    "ACCEPT_TERMS_MESSAGE": "Veuillez accepter les conditions d'utilisation",
    "RECOVERY_PASSWORD_TITLE": "Tapez votre mot de passe enregistré et nous vous enverrons un e-mail de récupération de mot de passe.",
    "EMAIL_NOT_EXISTS": "Compte utilisateur introuvable",
    "SIGN_IN_BUTTON": "S'identifier",
    "EMAIL_PLACEHOLDER": "Adresse e-mail",
    "ENTER_PASSWORD": "Entrer le mot de passe",
    "KEEP_SIGN_COMPUTER": "Me garder connecté sur cet ordinateur",
    "DON'T_HAVE_ACCOUNT": "Je n'ai pas de compte",
    "EMAIL_REQUIRED": "Le champ e-mail est obligatoire",
    "EMAIL_INVALID": "Le courriel est invalide",
    "ONLY_NUMERIC": "Seules les valeurs numériques autorisées",
    "INVALID_OTP": "OTP invalide",
    "FORGOT_PASSWORD": "Mot de passe oublié",
    "SIGN_IN": "Inscription gratuite",
    "PASSWORD_PLACEHOLDER": "Mot de passe",
    "PASSWORD_REQUIRED": "Le champ mot de passe est obligatoire",
    "PASSWORD_INCORRECT": "Mot de passe incorrect",
    "CHECK_OPTION": "Veuillez cocher l'option",
    "HAVE_BACKUP": "J'ai sauvegardé le code",
    "PASSWORD_MIN_MAX": "Le mot de passe doit contenir au moins une majuscule, au moins une minuscule, au moins un chiffre, au moins un caractère spécial et minimum 6 et maximum 18",
    "CONFIRM_PASSWORD_MISMATCH": "Les mots de passe doivent correspondre",
    "PASSWORD_CHANGE_SUCCESS": "Mot de passe réinitialisé avec succès",
    "PASSSWORD_RESET": "Réinitialisation du mot de passe",
    "CURRENT_PASSWORD_REQUIRED": "Le champ Mot de passe actuel est obligatoire",
    "CONFIRM_PASSWORD_REQUIRED": "Le champ de confirmation du mot de passe est obligatoire",
    "CONFIRM_PASSWORD": "Confirmer le nouveau mot de passe",
    "UPDATE_PASSWORD": "Mettre à jour le mot de passe de connexion",
    "LOGIN": "Connexion",
    "ORDER_HISTORY": "Historique des commandes",
    "DEFAULT_FIAT_CURRENCY": "Devise Fiat par défaut",
    "PAGE_AFTER_LOGIN": "Page par défaut après la connexion",
    "DEFAULT_LANGUAGE": "Ma langue par défaut",
    "REF_CODE_OPTION": "Code de parrainage (facultatif)",
    "CURRENT_PASSWORD": "Mot de passe actuel",
    "NEW_PASSWORD": "nouveau mot de passe",
    "REFERRAL_CODE": "Code de référence",
    "I_AGREE": "J'accepte et j'accepte les",
    "REFERRAL": "Référence",
    "YOUR_REFERRAL_ID": "Votre identifiant de parrainage",
    "INVITE_FRIENDS": "Inviter des amis",
    "YOUR_TOTAL_REFERRAL": "Votre revenu total de parrainage",
    "TERMS": "termes",
    "AND": "et",
    "PRIVACY": "Politique de confidentialité",
    "PASSWORD": "Mot de passe",
    "OTP": "OTP",
    "DEFINITION": "Définitions",
    "OUR_TERMS": "Nos conditions",
    "TERMS_CONTENT_1": "Les présentes conditions d'utilisation de Exchange sont conclues entre vous (ci-après dénommé « vous » ou « votre ») et les opérateurs de Exchange (tels que définis ci-dessous). En accédant, en téléchargeant, en utilisant ou en cliquant sur \"J'accepte\" pour accepter tout service Exchange (tel que défini ci-dessous) fourni par Exchange (tel que défini ci-dessous), vous reconnaissez avoir lu, compris et accepté tous les termes et conditions stipulées dans les présentes Conditions d'utilisation (ci-après dénommées « les présentes Conditions ») ainsi que dans notre Politique de confidentialité sur https://www Exchange.com/en/privacy. En outre, lorsque vous utilisez certaines fonctionnalités des Services, vous pouvez être soumis à des conditions générales supplémentaires spécifiques applicables à ces fonctionnalités.",
    "TERMS_CONTENT_2": "En accédant, en utilisant ou en tentant d'utiliser les Services Exchange à quelque titre que ce soit, vous reconnaissez que vous acceptez et convenez d'être lié par ces Conditions. Si vous n'êtes pas d'accord, n'accédez pas à Exchange et n'utilisez pas les services Exchange.",
    "TERMS_CONTENT_3": "Exchange fait référence à un écosystème comprenant des sites Web Exchange (dont les noms de domaine incluent, mais sans s'y limiter, https://www Exchange.com), des applications mobiles, des clients, des applets et d'autres applications développées pour offrir les services Exchange, et comprend des plates-formes, des sites Web et des clients exploités de manière indépendante.",
    "TERMS_CONTENT_4": "Les opérateurs Exchange désignent toutes les parties qui gèrent Exchange, y compris, mais sans s'y limiter, les personnes morales, les organisations non constituées en société et les équipes qui fournissent des services Exchange et sont responsables de ces services. Pour plus de commodité, sauf indication contraire, les références à « Exchange » et « nous » dans les présentes Conditions signifient spécifiquement Exchange.",
    "TERMS_CONTENT_5": "Les services Exchange font référence à divers services qui vous sont fournis par Exchange qui sont basés sur les technologies Internet et/ou blockchain et proposés via les sites Web Exchange, les applications mobiles, les clients et d'autres formes (y compris les nouveaux rendus possibles par le développement technologique futur). Les services Exchange incluent, mais sans s'y limiter, les composants de l'écosystème Exchange tels que les plateformes d'échange d'actifs numériques, le secteur du financement, Exchange Labs, Exchange Academy, Exchange Charity, Exchange Info, Exchange Launchpad, Exchange Research, Exchange Chain, Exchange X, Exchange Fiat Gateway, les services existants offerts par Trust Wallet et les nouveaux services qui seront fournis par Exchange",
    "SEND_CODE": "Envoyer le code",
    "VERIFY_RECAPTCHA": "Vérifier le recaptcha",
    "MOBILE_NO": "Numéro de portable",
    "ENTER_MOBILE_NO": "Entrez le numéro de téléphone portable",
    "VERIFY_CODE": "Code de vérification",
    "REQUIRED": "Obligatoire",
    "PRICE_ONLY_NUMERIC": "Prix uniquement valeur numérique",
    "FIRST_NAME_ALPHABET": "firstName Doit être rempli avec des alphabets",
    "LAST_NAME_ALPHABET": "lastName Doit être rempli avec des alphabets",
    "BLOCKNO_NAME_ALPHABET": "blockNo Doit être rempli avec des alphabets",
    "STATE_NAME_ALPHABET": "état Doit être rempli avec des alphabets",
    "CITY_NAME_ALPHABET": "ville Doit être rempli avec des alphabets",
    "POSTAL_CODE_MUST_NUMBER": "postalCode Doit être rempli avec des chiffres",
    "INVALID_EMAIL": "Email invalide",
    "ONLY_NUMERIC_POSITIVE": "Seules les valeurs numériques positives sont autorisées",
    "QUANTITY_REQUIRED": "Le champ Quantité est obligatoire",
    "MAX_LIMIT_REQUIRED": "Le champ de limite maximale est OBLIGATOIRE",
    "MAX_LIMIT_4": "Limite maximale 4",
    "INVALID_CODE": "Code invalide",
    "TERMS_REQUIRED": "Le champ Termes est obligatoire",
    "PERSONAL_DETAILS": "Détails personnels",
    "FULL_NAME": "Nom complet",
    "RESIDENTIAL_ADDRESS": "Adresse résidentielle",
    "BUILDING_BLOCK": "Nom du bâtiment/bloc",
    "ADDRESS": "Adresse",
    "STATE_PROVISION": "Etat / Province",
    "CITY": "Ville",
    "POSTAL_CODE": "code postal",
    "COUNTRY": "Pays",
    "EDIT_PROFILE": "Modifier mon profil",
    "Submit": "Soumettre",
    "FIRST_NAME": "Prénom",
    "LAST_NAME": "Nom de famille",
    "NAME": "Nom",
    "PROFILE_EDIT_SUCCESS": "Merci, votre profil a été mis à jour !",
    "SOMETHING_WRONG": "Quelque chose s'est mal passé",
    "NO_DATA": "Pas de données disponibles",
    "NO_ORDER": "Il n'y a pas de commande",
    "ORDER_CANCEL": "Votre commande annulée avec succès",
    "ORDER_ALREADY_COMPLETED": "Votre commande déjà terminée",
    "ORDER_ALREADY_CANCEL": "Votre commande déjà annulée",
    "REGISTER_BANK_ACCOUNT": "Ici, vous pouvez enregistrer votre compte bancaire dans le système qui vous permettra de retirer des fonds de Exchange",
    "ADD_BANK_ACCOUNT": "Ajouter un compte bancaire",
    "ADD_BANK": "Ajouter une banque",
    "READ": "Lis",
    "MY_BANK_ACCOUNT": "Mes comptes bancaires",
    "DEFAULT": "Défaut",
    "BANK_ACCOUNT": "Compte bancaire",
    "CHANGE": "monnaie",
    "BANK_NAME": "Nom de banque",
    "ACCOUNT_NO": "N ° de compte",
    "ACCOUNT_NUMBER": "Numéro de compte",
    "ACCOUNT_HOLDER_NAME": "Nom du titulaire du compte",
    "IBAN_SWIF": "IBAN/Code Swift",
    "IBAN_CODE": "Code IFSC",
    "BANK": "Banque",
    "STATUS": "Statut",
    "CREATED_ON": "Créer sur",
    "TWO_FA": "Authentification à 2 facteurs",
    "EDIT": "Modifier",
    "DELETE": "Supprimer",
    "TWO_FA_MSG": "Vous devez activer 2FA pour retirer des fonds fiduciaires.",
    "BANK_EDIT_SUCCESS": "Coordonnées bancaires mises à jour avec succès",
    "BANK_ADD_SUCCESS": "Coordonnées bancaires ajoutées avec succès",
    "BANK_DELETE_SUCCESS": "Coordonnées bancaires supprimées avec succès",
    "BANK_SET_PRIMARY_SUCCESS": "Coordonnées bancaires par défaut mises à jour avec succès",
    "UPDATE": "Mise à jour",
    "NOTES": "Remarques",
    "MIN_DEPOSIT_LIMIT": "Limite de dépôt minimum",
    "DEPOSIT_TIME": "Le temps de dépôt prendra 4 à 24 heures en raison du réseau bancaire",
    "CHAT_ONLY_TRADE": "Chat uniquement informations sur les détails du commerce",
    "WITHDRAW_FIAT_DEPOSIT": "Retirer le dépôt Fiat",
    "WITHDRAW_FIAT": "Retirer Fiat",
    "AVOID_WORNG_WORDS": "Évitez les mots inutiles",
    "TRANSFER_PAYMENT_BUTTON": "Cliquez sur le bouton Transférer le paiement pour terminer le paiement au vendeur",
    "NEED_SUPPORT": "Besoin de soutien?",
    "CREAT_SUPPORT_TICKET": "Créer un ticket d'assistance",
    "SUPPORT_DETAILS": "Détails de l'assistance",
    "2FA_VERIFID": "Vérification du code 2FA",
    "PASSWORD_TITLE": "Pour des mesures de sécurité, votre mot de passe doit contenir :",
    "PASSWORD_DESCRIPTION1": "un minimum de 6 caractères",
    "PASSWORD_DESCRIPTION2": "au moins une lettre MAJUSCULE (A, B, X, Y...)",
    "PASSWORD_DESCRIPTION3": "au moins un chiffre (0,1,2,9...)",
    "PASSWORD_DESCRIPTION4": "au moins un caractère spécial (! @ # $ ^ *...)",
    "PASSWORD_DESCRIPTION5": "un maximum de 18 caractères",
    "PASSWORD_DESCRIPTION6": "au moins une lettre MINUSCULE (a,b,x,y...)",
    "TWO_FA_DESCRIPTION1": "Activez l'authentification à deux facteurs comme mesure de sécurité supplémentaire, pour protéger vos fonds et pouvoir retirer. Veuillez utiliser Google Authenticator que vous pouvez",
    "TWO_FA_DESCRIPTION2": "Veuillez télécharger l'authentificateur Google en cliquant sur \"Télécharger ici\" et scanner le code QR. Vous recevrez un code à 6 chiffres, qui devra être saisi dans la case 2FA.",
    "TWO_FA_DESCRIPTION3": "Juste en bas du code à 32 chiffres dans un livre blanc pour votre sécurité si vous avez oublié le code 2FA pour retirer des fonds",
    "DOWNLOAD_HERE": "Télécharger ici",
    "HOW_ENABLE": "Comment activer",
    "ENABLE": "Activer 2FA",
    "DISABLE": "Désactiver 2FA",
    "ENTER_TWO_FA_CODE": "Entrez le code 2FA à 6 chiffres",
    "TWO_FA_CODE": "Votre code de sécurité à 32 chiffres",
    "SCAN_QR_CODE": "Scanner le code QR",
    "DISABLED": "désactivé",
    "ENABLED": "Activé",
    "TWO_FA_ENABLE_SUCCESS": "2FA activé avec succès",
    "TWO_FA_DISABLE_SUCCESS": "2FA désactivé avec succès",
    "EDIT_SETTING_SUCCESS": "Paramètre mis à jour avec succès",
    "IDENTITY_DOCUMENT": "Document d'identité",
    "IDENTIFICATION_DOCUMENT": "Document d'identification",
    "SELECTED_ID_NUMBER": "Entrez le numéro d'identification du document sélectionné",
    "FRONT_SIDE": "Face avant",
    "PICTURE_SCAN": "Photo ou scan montrant les 4 coins",
    "MAX_1MB_IMG": "Max 1 Mo en jpg/png",
    "BACK_SIDE": "Verso",
    "SIDE": "Côté",
    "EXECTED_PRICE": "Prix exécuté",
    "EXECUTED": "Réalisé",
    "ADA": "ADA",
    "SELFIE_SELECTED_ID": "Selfie avec ID sélectionné",
    "IDENTITY_DOCUMENT_TITLE1": "Ici, vous pouvez vérifier votre identité en téléchargeant l'un des documents d'identité approuvés",
    "IDENTITY_DOCUMENT_DESCRIPTION1": "Toutes les images doivent être clairement visibles et le texte également clairement visible",
    "IDENTITY_DOCUMENT_DESCRIPTION2": "Si le texte n'est pas lisible, le visage flou, l'image floue doit être disqualifiée et le statut ne sera PAS vérifié.",
    "IDENTITY_DOCUMENT_DESCRIPTION3": "Le selfie ou la photo avec votre identifiant sélectionné doit montrer un visage clair tenant l'identifiant sélectionné. Veuillez voir un exemple",
    "IDENTITY_DOCUMENT_DESCRIPTION4": "Si vous souhaitez modifier votre pièce d'identité, veuillez contacter notre",
    "IDENTITY_HINT1": "Max. Taille 9 Mo, jpg, png, pdf autorisés",
    "IDENTITY_HINT2": "Max 9 Mo en jpg/png/pdf",
    "HERE": "Ici",
    "IDENTITY_DOCUMENT_VERIFIED": "Votre pièce d'identité a été téléchargée correctement",
    "SUPPORT_TEAM": "équipe de soutien",
    "TICKET_FOR": "Billet pour",
    "MSG_TO_SUPPORT_TEAM": "Message à l'équipe d'assistance",
    "ADDRESS_DOCUMENT_TITLE1": "Preuve d'adresse résidentielle",
    "ADDRESS_DOCUMENT_TITLE2": "Document de preuve d'adresse",
    "ADDRESS_DOCUMENT_TITLE3": "Télécharger le document",
    "ADDRESS_DOCUMENT_DESCRIPTION1": "Le document doit indiquer clairement votre nom complet et votre adresse complète.",
    "ADDRESS_DOCUMENT_DESCRIPTION2": "- Le document ne doit PAS dater de plus de 3 mois",
    "ADDRESS_DOCUMENT_DESCRIPTION3": "- Facture d'électricité approuvée, facture de gaz, téléphone fixe, facture Internet. Facture de téléphone portable NON acceptée.",
    "ADDRESS_DOCUMENT_DESCRIPTION4": "Facture de services publics (factures de services publics approuvées : facture d'électricité, facture de gaz, téléphone fixe, facture Internet). Téléphone portable non accepté.",
    "ADDRESS_DOCUMENT_DESCRIPTION5": "Si vous souhaitez modifier votre document d'adresse, veuillez contacter notre",
    "ADDRESS_DOCUMENT_VERIFIED": "Votre justificatif de domicile a été envoyé",
    "DRIVING_LICENSE": "Permis de conduire",
    "UTILITY_BILL": "Facture de services publics",
    "BANK_STATEMENT": "relevé bancaire",
    "CREDIT_CARD_STATEMENT": "Déclaration de carte de crédit",
    "MUNICIPALITY_REGISTRATION": "Enregistrement de la municipalité",
    "GOVERNMENT_ISSUED_ID": "Document d'identification délivré par le gouvernement",
    "PASSPORT": "Passeport",
    "PANCARD": "Pancarte",
    "GAS_BILL": "Facture de gaz",
    "AADHAR_CARD": "Carte Adhar",
    "TOO_LARGE": "Trop grande",
    "INVALID_IMAGE": "Veuillez sélectionner un format valide",
    "IDENTITY_DOC_UPLOAD_SUCCESS": "Pièce d'identité mise à jour avec succès",
    "ADDRESS_DOC_UPLOAD_SUCCESS": "Document résidentiel mis à jour avec succès",
    "NOT_APPLY": "Ne s'applique pas",
    "VERIFIED": "Vérifié",
    "NOT_VERIFIED": "Non vérifié",
    "REJECTED": "Rejeté",
    "BASIC": "Basique",
    "ADVANCED": "Avancé",
    "PRO": "Pro",
    "BASIC_PENDING": "En attente de base",
    "BASIC_SUBMITTED": "Soumis de base",
    "SUBMITTED": "Soumis",
    "BASIC_VERIFIED": "Vérifié de base",
    "ADVANCED_Pending": "Avancé en attente",
    "PRO_PENDING": "Pro en attente",
    "BASIC_USER": "Utilisateur de base",
    "ADVANCED_USER": "Utilisateur avancé",
    "PRO_USER": "Utilisateur professionnel",
    "TYPE_BASIC_DESCRIPTION1": "Dépôt crypto jusqu'à 10,00 € en valeur",
    "TYPE_BASIC_DESCRIPTION2": "Négociez les marchés de la crypto et de la fiat",
    "TYPE_BASIC_DESCRIPTION3": "Retirez crypto et fiat jusqu'à 10,00 € en valeur pour un maximum de 2500 $",
    "ID_ADDRESS_PROOF": "Pièce d'identité et preuve d'adresse",
    "DEFAULT_BANK_ACCOUNT_DETAIL": "Preuve de compte bancaire (uniquement la banque de retrait par défaut)",
    "USER_ID": "Identifiant d'utilisateur",
    "MEMBER_SINCE": "Membre depuis",
    "VERIFICATION_TYPE": "Type de vérification",
    "EMAIL_PHONE": "Adresse e-mail et téléphone",
    "VERIFY_NOW": "Vérifiez maintenant",
    "PENDING": "En attente",
    "PHONE": "Téléphoner",
    "TRANS_WALLET_AMOUNT": "Montant du portefeuille de transfert",
    "WITHDRAW_ACCOUNT": "Retirer un compte",
    "FIAT_WITHDRAW_DESCRIPTION1": "Retrait minimal",
    "FIAT_WITHDRAW_DESCRIPTION2": "Le retrait prendra 24 à 48 heures en raison du réseau bancaire / des jours fériés",
    "FINAL_WITHDRAW_AMOUNT": "Montant du retrait final",
    "WALLET_BALANCE": "Solde du portefeuille",
    "ENTER2FA_CODE": "Entrez le code 2FA",
    "WALLET_TRANSFER": "Transfert de portefeuille",
    "MIN_WITHDRAW_LIMIT": "Limite minimale de retrait",
    "WITHDRAW_TIME_TAKE": "Le temps de retrait prendra 4 à 24 heures en raison du réseau bancaire",
    "WITHDRAW_AMOUNT": "Montant du retrait",
    "FUND_TRANSFER": "Transfert de fonds",
    "RECEIVER_EMAIL": "E-mail du destinataire",
    "WITHDRAW_ADDRESS": "Adresse de retrait",
    "ALLOW_NUMERIC": "Uniquement numérique autorisé",
    "QUANTITY_ONLY_NUMERIC": "Quantité uniquement valeur numérique",
    "SIDE_REQUIRED": "Le champ latéral est OBLIGATOIRE",
    "INVALID_SIDE": "Côté invalide",
    "MIN_LIMIT_REQUIRED": "Le champ Limite min est OBLIGATOIRE",
    "SELECT_DATE": "Veuillez sélectionner la date",
    "GREATER_THEN_CURRENT": "Veuillez sélectionner une date supérieure à la date actuelle",
    "LESS_LIMIT_PURCHASE": "Le prix limite doit être inférieur au prix limite",
    "ACCEPT_TERMS": "Veuillez accepter les termes et la politique",
    "BALANCE": "Solde",
    "DISTANCE": "Distance",
    "INSUFFICIENT_BALANCE": "Solde insuffisant",
    "KYC_SUBMIT_ALERT": "Veuillez soumettre vos détails kyc",
    "INVALID_BANK_ACCOUNT": "Compte bancaire invalide",
    "VERIFICATION_LINK": "Lien de vérification envoyé à l'adresse e-mail",
    "INVALID_TOKEN": "jeton invalide",
    "EXPIRY_TOKEN": "Jeton d'expiration",
    "DEPOSIT_QR_CODE": "Pour déposer utiliser ce QR",
    "COIN_ADDRESS": "Votre adresse de pièce",
    "COPY_ADDRESS": "Copier l'adresse",
    "COIN_DEPOSIT_DESCRIPTION1": "N'envoyez que des LTC à cette adresse de dépôt.",
    "COIN_DEPOSIT_DESCRIPTION2": "Dépôt minimal : 0,001 LTC",
    "COIN_DEPOSIT_DESCRIPTION3": "L'envoi de pièces ou de jetons autres que LTC à cette adresse peut entraîner la perte de votre dépôt.",
    "WITHDRAW_TOO_LOW": "Montant final trop bas",
    "FINAL_AMOUNT": "Le montant final",
    "FIAT_DEPOSIT_DESCRIPTION1": "Caution minimale : 10 €",
    "FIAT_DEPOSIT_DESCRIPTION2": "Doit télécharger une preuve de dépôt en pdf / jpg et entrer le numéro de référence / ID",
    "ADMIN_ACCOUNT": "Compte administrateur",
    "DEPOSIT": "Verser",
    "DEPOSIT_AMOUNT": "Montant du dépôt",
    "UPLOAD_PROOF": "Télécharger une preuve",
    "STAKE_AMOUNT": "Montant de la mise",
    "T_HAVE_READ": "j'ai lu le",
    "DEPOSIT_REQUEST_SUCCESS": "Demande de dépôt envoyée avec succès",
    "DEPOSIT_TOO_LOW": "Montant du dépôt trop bas",
    "SELECT_CURRENCY": "Sélectionnez la devise",
    "INVALID_WALLET_TYPE": "Type de portefeuille non valide",
    "WALLET_MIS_MATCH": "De portefeuille et de portefeuille devrait être différent",
    "TO_WALLET": "Au portefeuille",
    "FROM_WALLET": "Depuis le portefeuille",
    "WALLET_TRANSFER_SUCCESS": "Le processus de conversion du portefeuille s'est terminé avec succès",
    "OPEN_ORDER": "Commandes ouvertes",
    "CANCEL": "Annuler",
    "ORDERS": "Ordres",
    "SUBSCRIBE_ETH": "Abonnez-vous à l'ETH",
    "LOT_AMOUNT": "Montant du lot",
    "AVAILABLE_LOTS": "Disponible 10 Lots",
    "STAKE_LIMIT": "Limite de mise",
    "MINIMUM_LOT": "Au moins 1 lot",
    "LOT_SIZE": "La taille du lot",
    "INTEREST_PER_LOT": "Intérêt par lot",
    "INDIVIDUAL_MAX": "Maximum individuel",
    "VALUE_DATE": "Date de valeur",
    "INTEREST_RATE": "Taux d'intérêt",
    "INT_DURATION_TIME": "Date de distribution des intérêts",
    "REDEMPTION_DATE": "Date de remboursement",
    "EXPECT_INTEREST": "Intérêt attendu",
    "HAVE_READ_AND_AGREE": "J'ai lu et j'accepte les",
    "USER": "Utilisateur",
    "CURRENT_SUBSCRIPTION": "Abonnement actuel",
    "TYPE": "Taper",
    "RELEASE": "Libérer",
    "ENTER_CODE": "Entrez le code",
    "PRICE": "Prix",
    "LATEST_PRICE": "Dernier prix",
    "FLEXIBLE": "Souple",
    "LOCKED": "Fermé à clé",
    "SUBSCRIBE": "S'abonner",
    "STOP_LIMIT": "Limite d'arrêt",
    "STOP_MARKET": "Stop-market",
    "TRAILING_STOP": "Arrêt suiveur",
    "DEFAULT_THEME": "Thème par défaut pour le trading",
    "LIGHT_THEME": "Thème Lumière",
    "DARK_THEME": "Thème sombre",
    "GENERAL_SETTINGS": "réglages généraux",
    "GENERAL": "Général",
    "HIGH_YIELD": "Haut rendement",
    "CRYPTOS": "Cryptos",
    "VACATION": "Vacances",
    "DISABLE_ALL_ADVERTISMENT_SELL": "Désactivez toutes vos publicités pour vendre temporairement",
    "DISABLE_ALL_ADVERTISMENT_BUY": "Désactivez toutes vos publicités pour acheter temporairement",
    "YOUR_BALANCE": "Votre solde",
    "ESTIMATED_VALUE": "Valeur estimée:",
    "BUSD": "BUSD",
    "BNB": "BNB",
    "TRX": "TRX",
    "XRP": "XRP",
    "OTHERS": "Autre",
    "TOTAL_BALANCE": "Solde total du compte",
    "TRANSFER_FUND": "Transfert de fonds",
    "AMOUNT": "Montant",
    "WELCOME_TO": "Bienvenue à",
    "BANNER_DESCRIPTION_1": "Nous mettons le pouvoir entre vos mains pour",
    "BANNER_DESCRIPTION_2": "acheter, vendre et échanger de la monnaie numérique.",
    "GET_STARTED": "Commencer",
    "EXPLORE_MARKETS": "Explorez nos marchés",
    "EXPLORE_MARKETS_DESCRIPTION_1": "Le principal échange de devises Exchange au monde",
    "EXPLORE_MARKETS_DESCRIPTION_2": "Échangez Bitcoin, ETH et des centaines d'autres devises Exchange en quelques minutes.",
    "BUY": "Acheter",
    "DASHBOARD": "Tableau de bord",
    "ADMIN_ANNOUNCEMENT": "Annonce de l'administrateur",
    "LAST_LOGIN": "Dernière connexion",
    "ADMIN": "Administrateur",
    "ACCOUNT": "Compte",
    "KYC_VERIFICATION": "Vérification KYC",
    "EMAIL": "E-mail",
    "MOBILE_PHONE Phone": "Téléphone portable",
    "2FA_TOOL_TIP1": "Afin de retirer des fonds, veuillez activer l'authentification à 2 facteurs",
    "ENABLE_NOW": "Activer maintenant",
    "DISABLE_NOW": "Désactiver maintenant",
    "LOGIN_PASSWORD": "Mot de passe",
    "ALERT": "Alerte",
    "WHEN_ENABLE_DISABLE_2FA": "Quand activer / désactiver 2FA",
    "WHEN_LOGIN_PWD_CHG": "Lorsque le mot de passe de connexion change",
    "MARKTING_PROMOTION_EMAIL": "E-mail de marketing et de promotion",
    "WALLET_BAL": "Solde du portefeuille",
    "AMOUNT_TO_STAKE": "Montant intéressé à miser",
    "SUBSCRIPTION_AMOUNT": "Montant de la souscription",
    "SUBSCRIPTION_DATE": "Date de souscription",
    "WITHDRAW": "Retirer",
    "TRANSFER": "Transférer",
    "BTCUSDT": "BTCUSDT",
    "FIAT_HISTORY": "Histoire de Fiat",
    "CRYPTO_HISTORY": "Historique des crypto-monnaies",
    "P2P_HISTORY": "Historique des commandes P2P",
    "ADV_FIAT_DEPOSIT": "Dépôt Fiat avancé jusqu'à",
    "ADV_FIAT_WITHDRAW": "Retrait Fiat avancé jusqu'à",
    "ALL_ADVANCE_FEATURE": "Toutes les fonctionnalités avancées",
    "PLUS": "PLUS",
    "FIAT_DEPOSIT": "Dépôt Fiat",
    "DEPOSIT_BANK_INFO": "Informations sur la banque de dépôt",
    "SPOT_BALANCE": "Solde au comptant",
    "ACCOUNT_FEATURES": "Fonctionnalités complètes des comptes",
    "UNLIMITED_FIAT_DEP_WITH": "Dépôt et retrait Fiat ILLIMITÉS",
    "DERIVATIVE_BAL": "Solde dérivé",
    "P2P_BAL": "Solde P2P",
    "STATISTICS": "Statistiques",
    "TOTAL_SPOT_TRADE": "Total des transactions au comptant terminées",
    "TOTAL_DERIVATIVE_TRADE": "Total des produits dérivés placés",
    "P2P_TRADE": "Commerce P2P",
    "OPEN": "Ouvrir",
    "SPOT_TRADE": "Négociation au comptant",
    "DERIVATIVE_TRADE": "Négociation de produits dérivés",
    "2FA_PASS_UPDATE": "Mise à jour à deux facteurs et mot de passe",
    "ESCROW_STATUS": "Statut d'entiercement",
    "COMPLETED": "Terminé",
    "RECENT_TRANSACTION": "transactions récentes",
    "LOGIN_HISTORY": "Historique de connexion",
    "NOTIFICATION_HISTORY": "Historique des notifications",
    "HISTORY": "Histoire",
    "DATE": "Date",
    "SYMBOL": "Symbole",
    "TRANSACTION_REF": "Réf.",
    "NO_RECORD": "Aucun enregistrement",
    "POST_AD": "Publier une annonce",
    "MINUTES": "Minutes",
    "PLEASE_MAKE_PAYMENT": "Veuillez effectuer un paiement dans les 30:00 minutes, sinon la commande sera automatiquement annulée.",
    "TRADE_LIMIT": "Limite commerciale",
    "TRANSFER_PAYMENT": "Paiement transféré",
    "RELEASE_ASSET": "Libérer l'actif",
    "DISPUTE_TRADE": "Différend commercial",
    "RLY_TO_ADMIN": "Répondre à l'administrateur",
    "CLOSE_THE_TICKET": "Satisfait, Fermer ce ticket",
    "WANT_PAY": "je veux payer",
    "CANCEL_ORDER": "annuler la commande",
    "WILL RECEIVE": "Je vais recevoir",
    "CALNEL_AD": "Voulez-vous vraiment annuler l'annonce ?",
    "IP_ADDRESS": "Adresse IP",
    "LOCATION": "Emplacement",
    "DEVICE": "Appareil",
    "FIAT_CRYPTO": "Fiat/Crypto",
    "TOTAL": "Total",
    "FIAT_WALLET": "Portefeuille Fiat",
    "CRYPTO_WALLET": "Portefeuille cryptographique",
    "SPOT": "ENDROIT",
    "DERIVATIVE": "Dérivé",
    "P2P": "P2P",
    "TRIGGER_CONDITION": "Conditions de déclenchement",
    "SELL_BITCOIN": "Vendre des bitcoins",
    "BUY_BITCOIN": "Acheter des bitcoins",
    "BITCOIN": "Bitcoin",
    "ETHEREUM": "Ethereum",
    "TOTAL_STAKING": "Mise totale",
    "RIPPLE": "Ondulation",
    "LITE_COION": "Litecoin",
    "TETHER_COIN": "TetherCoin",
    "FIND_COIN": "Trouver une pièce",
    "WALLET": "Porte monnaie",
    "FUND": "Fonds",
    "HOME": "Domicile",
    "FEES": "Frais",
    "FAQ": "FAQ",
    "TERMS_CONDITION": "termes et conditions",
    "TRANSFER_CONFIRM": "Confirmer le transfert",
    "STAKING_DELAILS": "Détails de jalonnement",
    "DAY_APY": "Jour APY",
    "YESTERDAY_APY": "Flexbile APY d'hier",
    "FLEXIBLE_INTERESTED": "Intérêt flexible pour mille",
    "PRIVACY_POLICY": "Politique de confidentialité",
    "REG_EMAIL_MOBILE": "Votre adresse e-mail enregistrée / numéro de téléphone portable",
    "DOWNLOAD_APP": "Télécharger l'application depuis",
    "MARKETS": "Marchés",
    "SPOT_MARKET": "Marché au comptant",
    "DERIVATIVE_MARKET": "Marché dérivé",
    "POLICY": "politique",
    "SUBMIT_POST": "Soumettre le message",
    "POST_ID": "ID de publication",
    "POSTED_ON": "Posté sur",
    "MARKET": "Marché",
    "SUPPORT": "Soutien",
    "CONTACT_US": "Contactez-nous",
    "CONTACT_PARAGRAPH_1": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition. Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500",
    "SUPPORT_TICKET": "Billet d'assistance",
    "NEWS_UPDATE_TITLE": "Recevez les dernières nouvelles et mises à jour",
    "COPY_RIGHT": "© Copyright ©{{YEAR}} Tous droits réservés",
    "CONNECT_WITH_US": "Connecte-toi avec nous",
    "CONTACT": "Contacter",
    "PROFILE": "Profil",
    "PERSONAL": "Personnel",
    "MY_ACCOUNT": "Mon compte",
    "LOGOUT": "Se déconnecter",
    "KYC": "KYC",
    "CONTACT_DETAILS": "Détails du contact",
    "BANK_ACCOUNT_DETAIL": "Détails de compte en banque",
    "PROFILE_DESCRIPTION1": "Vos données personnelles doivent être introduites strictement <b>comme indiqué dans vos pièces d'identité officielles et votre justificatif de domicile</b> votre adresse doit être celle indiquée dans le justificatif de domicile requis pour la vérification du compte. Si vous avez des doutes, écrivez-nous à <a>{{SUPPORT_MAIL}}</a>",
    "PROFILE_IMAGE": "Image de profil",
    "FILE_FORMAT1": "jpg/jpeg/png maximum {{TAILLE}}",
    "CHANGE_EMAIL": "Changer l'e-mail",
    "PHONE_NUMBER": "Numéro de téléphone",
    "SEND_OTP": "Envoyer OTP",
    "RESEND_OTP": "Renvoyer OTP",
    "ENTER_OTP": "Entrez OTP",
    "SEC": "Seconde",
    "UPDATE_PHONE_NO": "Mettre à jour le numéro de téléphone",
    "ADD_ANOTHER_ACCOUNT": "Ajouter un autre compte",
    "WHY_COIN": "Pourquoi Coin",
    "PARAGRAPH_1": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition. Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500",
    "GOLD": "Or",
    "PARAGRAPH_2": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition. Le Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500. Le Lorem Ipsum est simplement un texte factice de l'industrie de l'impression et de la composition.",
    "START_TRADE": "Commencer le trading au comptant",
    "PARAGRAPH_3": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition. Le Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500. Le Lorem Ipsum est simplement un texte factice de l'industrie de l'impression et de la composition.",
    "START_DERIVATIVE": "Démarrer le trading de dérivés",
    "LIGHT": "Léger",
    "MODE": "Mode",
    "DARK": "Sombre",
    "COIN": "Pièce de monnaie",
    "FEATURE": "Caractéristiques",
    "FREE": "Libre",
    "INSTANT": "Instantané",
    "TRADING": "Commerce",
    "FIAT_EASILY": "Fiat facilement",
    "PROMPT": "Rapide",
    "KYC_VERIFY": "Vérification KYC",
    "SECURE_PLATFORM": "Notre plateforme sécurisée",
    "2FA_PROTECT": "Protégé 2FA",
    "PARAGRAPH_4": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition.",
    "PARAGRAPH_5": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition.",
    "PARAGRAPH_6": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition.",
    "256-BIT": "Cryptage 256 bits",
    "SECURE_WALLET": "Portefeuille sécurisé",
    "JOIN_REFERRAL_HEADING": "Rejoignez notre programme de parrainage",
    "EARN_MONEY": "Commencez à gagner de l'argent en invitant des amis",
    "JOIN_REFERRAL": "Rejoignez notre recommandation",
    "GET_STARTED_HEADING": "Démarrez en quelques minutes",
    "SIGN_UP": "S'inscrire",
    "ACCOUNT_ACCESS": "Accès instantané au compte en 2 minutes",
    "VERIFY": "Vérifier",
    "PASSWORD_ADDRESS": "avec passeport et preuve d'adresse",
    "TRADE": "Échange",
    "PAIR_PROFIT": "avec multi-paire et livre profit",
    "TRADE_WITH": "Commerce avec l'application mobile",
    "FOOTER_P": "Compatible avec plusieurs appareils, commencez à trader en toute sécurité et commodité.",
    "P2P_TRADING": "Commerce P2P",
    "PARAGRAPH_7": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition. Lorem Ipsum a été la norme de l'industrie.",
    "I_WANT_TO": "Je veux",
    "ACCOUNT_FROZEN": "Les clics malveillants entraîneront le blocage du compte",
    "SELL": "Vendre",
    "PAY_WITH_TIME_LIMIT": "Payez dans le délai imparti, sinon la commande sera automatiquement annulée 1",
    "PAY_TRADE_TERMS": "Ne payez que selon les conditions commerciales",
    "CONFIRM_PAYMENT": "Confirmer le paiement",
    "PAYMENT_MADE_SELLER": "Veuillez confirmer que le paiement a été effectué auprès du vendeur.",
    "SELECT_CRYPTO": "Sélectionnez Crypto",
    "PAYMENT_TYPE": "Type de paiement",
    "START_p2p": "Démarrer le P2p",
    "ID_DOCUMENT": "Pièce d'identité :",
    "ADDRESS_PROOF": "Preuve d'adresse:",
    "2FA_HEADING": "Authentification en 2 étapes",
    "DIGITAL_CODE": "Entrez le code à six chiffres 2FA",
    "PASTE_CODE": "Coller le code",
    "CONFIRM": "Confirmer",
    "SECURITY_SETTINGS": "Les paramètres de sécurité",
    "POST_NEW_AD": "Publier une nouvelle annonce",
    "P2P_STATISTICS": "Statistiques P2P",
    "TOTAL_TRADES": "Nombre total de transactions",
    "FIRST_TRADE": "Premier échange",
    "TRADES": "métiers",
    "COMPLETION": "achèvement",
    "AVL": "Avl",
    "CREATED_TIME": "Heure de création",
    "ORDER_ID": "numéro de commande",
    "ATTACHMENT": "Attachement",
    "MORE_ABOUT_SUPPORT": "En savoir plus sur l'assistance",
    "LOGIN_ISSUE": "Problème de connexion",
    "DEPOSIT_ISSUE": "Problème de dépôt",
    "WITHDRAW_ISSUE": "Retirer le problème",
    "ADMIN_RLY": "Réponse de l'administrateur sur",
    "CONFIRM_MY_POST": "Confirmer ma publication",
    "FILTER_BY": "Filtrer par",
    "REPLAY": "Réponse",
    "BACK": "Arrière",
    "YOUR_API_KEY": "Vos clés API",
    "ID": "Identifiant",
    "CREATED": "Créé",
    "PERMISSION": "Autorisations",
    "ACTION": "Action",
    "STAKE_NOW": "Misez maintenant",
    "LOADING": "Chargement...",
    "INVALID_URL": "URL invalide",
    "TRANSFER_BITCOIN": "Transférer Bitcoin",
    "TICKET_ID": "ID de billets",
    "POST_HISTORY": "Historique des publications",
    "REF_KEY_LATER": "Nom facultatif pour cette clé. Cela vous aidera à référencer cette clé plus tard.",
    "IP_RESTRICTION": "Restrictions d'accès IP :",
    "SECURITY_REASONS": "Pour des raisons de sécurité, veuillez ne pas divulguer votre ou vos clés à des tiers non fiables. Nous recommandons aux utilisateurs d'ajouter leurs adresses IP à chacune des clés API. Un maximum de quatre (4) adresses IP peuvent être ajoutées à chaque clé. Pour ajouter plusieurs adresses IP, saisissez-les séparément avec des virgules entre elles. par exemple192.168.1.1,192.168.1.2,192.168.1.3",
    "CREATE_API_KEY": "Créer une clé API",
    "WRITE_SECRET_KEY": "Veuillez noter la clé secrète.",
    "SOMEWHERE_SAFE": "Écrivez-le dans un endroit sûr ! La clé secrète ne sera plus disponible une fois que vous quitterez cette page.",
    "SECRET": "Secret",
    "USD": "USD",
    "EURO": "euro",
    "CRYPTO": "Crypto",
    "LAST_PRICE": "Dernier prix",
    "FIAT": "Décret",
    "YOUR_FULL_NAME": "Ton nom complet",
    "SUBJECT": "Matière",
    "MESSAGE": "Message",
    "CONTRACTS": "Contrats",
    "FILLED_TOTAL": "Rempli/Total",
    "FILLED_PRICE": "Prix rempli",
    "FILLED": "Rempli",
    "TRADE_HISTORY": "Historique du commerce",
    "ORDER_PRICE": "Prix de la commande",
    "TRADE_TYPE": "Type de commerce",
    "ORDER_TYPE": "Type de commande",
    "ORDER_NO": "N ° de commande.",
    "Download_PDF": "Télécharger le PDF",
    "CANCEL_POST": "Annuler ma publication",
    "ORDER_TIME": "Temps de commande",
    "SIZE": "Taille",
    "TAKER_PRICE": "Bénéfice preneur",
    "STOP_LOSS": "Arrêter la perte",
    "GTC": "CGV",
    "IOC": "CIO",
    "FOK": "FOK",
    "LONG": "Longue",
    "SHORT": "Court",
    "VALUE": "Valeur",
    "COST": "Coût",
    "TP_SL": "TP/SL",
    "24H_CHANGE": "Changement 24h",
    "24_HIGH": "24h de haut",
    "24_LOW": "24h faible",
    "24H_VOLUME": "Volume 24h",
    "QTY": "Qté",
    "ORDER_BOOK": "Carnet de commande",
    "PLACE_ORDER": "Passer la commande",
    "LIMIT": "Limite",
    "PERPETUAL": "Perpétuel",
    "BTC_PAIRS": "Paires BTC",
    "ETH_PAIRS": "Paires ETH",
    "PAIRS": "Paires",
    "MARKET_CLOSE": "Fermeture du marché",
    "CLOSE_QTY": "Fermer Qté USD",
    "5CONTRACT_CLOSE": "5 Contrat(s) Seront clôturés au dernier prix négocié, et votre bénéfice attendu sera",
    "INCLUSIVE": "y compris les frais de colsing est.",
    "FEE_CONTENT": "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition. Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500",
    "ENTYRY_PRICE": "Prix d'entrée",
    "IDENTITY_VERIFICATION": "vérification d'identité",
    "LIQ_PRICE": "Liquide. Prix",
    "POSITION_MARGIN": "Marge de position",
    "UNREALIZED": "P&L non réalisé (%)",
    "DAILY_REALIZED": "P&L réalisé quotidiennement",
    "CLOSED_BY": "Près de",
    "RECENT_TRADE": "Transactions récentes",
    "TIME": "Temps",
    "STOP_PRICE": "Prix d'arrêt",
    "LIMIT_PRICE": "Prix limite",
    "POSITION": "Position",
    "EDIT_MY_POST": "Modifier mon message",
    "CRYPTO_CURRENCY": "Crypto-monnaie",
    "SELECT_COIN": "Sélectionnez la pièce",
    "Quantity": "Quantité",
    "PRICE_CURRENCY": "Devise du prix",
    "CURRENCY_MARKET_PRICE": "Prix actuel du marché",
    "PRICE_LIMIT_MARKET": "Limite de prix à partir de",
    "SHOW_MY_POST": "Afficher ma publication jusqu'à",
    "PERFERRED_PAYMENTS": "Paiements préférés",
    "PAYMENT_TO_MADE": "Paiement à effectuer",
    "PRICE_LIMIT_FROM": "Limite de prix à partir de",
    "PRICE_LIMIT_TO": "Limite de prix jusqu'à",
    "SELECT_PAYMENT": "Sélectionnez Paiement",
    "DURATION_DAYS": "Durée (jours)",
    "I_AGREE_ESCROW": "J'accepte de mettre sous séquestre mes fonds cryptographiques et j'accepte le",
    "DURATION": "Durée",
    "ALL": "Tout",
    "ETH": "EPF",
    "APY": "APY",
    "XRB": "XRB",
    "SPOT_WALLET": "Portefeuille ponctuel",
    "DERIVATIVE_WALLET": "Portefeuille dérivé",
    "P2P_WALLET": "Portefeuille P2P",
    "FORM": "Depuis",
    "QUANTITY": "Quantité",
    "FLEX_STAKING": "Implantation flexible",
    "LOCKED_STAKING": "Jalonnement verrouillé",
    "MIN_SUBSCRIPTION": "Abonnement minimal",
    "SUBSCRIPTION": "abonnement",
    "MAX_SUBSCRIPTION": "Souscription maximale",
    "STAKING_HISTORY": "Historique de jalonnement",
    "REDEMPTION_PERIOD": "Période de rédemption",
    "REDEMPTION": "Rachat",
    "READ_AND_AGREE": "J'ai lu et j'accepte les",
    "STAKING_TERMS": "Conditions de jalonnement",
    "INTEREST": "L'intérêt",
    "STAKING": "Jalonnement",
    "BTC/USD": "BTC/USD",
    "DIGITAL_ASSETS": "Principaux actifs numériques",
    "ONE_PLATFORM": "sous une seule plateforme",
    "MATKET_PRICE": "Prix des marchés",
    "SPOT_ORDERS": "Commandes ponctuelles",
    "DERIVATIVE_ORDERS": "Ordres dérivés",
    "P2P_ORDERS": "Commandes P2P",
    "STAKING_ORDERS": "Ordres de jalonnement",
    "MANA": "MANA",
    "BTC": "CTB",
    "DAYS": "Jours",
    "TOTAL_VOLUME": "Volume total",
    "TOTAL_TRADE_COMPLETE": "Total des échanges terminés",
    "ENTER_AMOUNT": "Entrer le montant",
    "VIEW_CHAT": "Afficher/Discuter",
    "PAY_BY": "Payer par",
    "ALL_PAYMENT": "Tous les paiements",
    "AVAILABLE": "Disponible",
    "SELLER_PAYMENT_TYPE": "Type de paiement du vendeur",
    "PAYMENT_TIME_LIMIT": "Délai de paiement",
    "RECENT_POST": "Post récent",
    "TO": "Pour",
    "DEPOSIT_CURRENCY": "Devise de dépôt",
    "YOUR": "Ton",
    "WALLET_ADDRESS": "Adresse du portefeuille"
}